import {
  IconBrandApple,
  IconBrandAuth0,
  IconBrandAws,
  IconBrandAzure,
  IconBrandBitbucket,
  IconBrandCoinbase,
  IconBrandDiscord,
  IconBrandDribbble,
  IconBrandDropbox,
  IconBrandFacebook,
  IconBrandFigma,
  IconBrandFoursquare,
  IconBrandGithub,
  IconBrandGitlab,
  IconBrandGoogle,
  IconBrandInstagram,
  IconBrandLine,
  IconBrandLinkedin,
  IconBrandMastodon,
  IconBrandMedium,
  IconBrandNextcloud,
  IconBrandNotion,
  IconBrandOauth,
  IconBrandPatreon,
  IconBrandPinterest,
  IconBrandReddit,
  IconBrandSlack,
  IconBrandSpotify,
  IconBrandStrava,
  IconBrandThreads,
  IconBrandTiktok,
  IconBrandTwitch,
  IconBrandWechat,
  IconBrandWindows,
  IconBrandWordpress,
  IconBrandX,
  IconBrandYandex,
  IconBrandZoom,
  IconNumber42Small,
} from "@tabler/icons-react"
import { type ComponentType } from "react"

import { type Providers } from "@/auth/providers"

export const ProviderIcons: Partial<
  Record<keyof typeof Providers, ComponentType>
> = {
  "42-school": IconNumber42Small,
  apple: IconBrandApple,
  auth0: IconBrandAuth0,
  "azure-ad-b2c": IconBrandAzure,
  bitbucket: IconBrandBitbucket,
  cognito: IconBrandAws,
  coinbase: IconBrandCoinbase,
  discord: IconBrandDiscord,
  dribbble: IconBrandDribbble,
  dropbox: IconBrandDropbox,
  facebook: IconBrandFacebook,
  figma: IconBrandFigma,
  foursquare: IconBrandFoursquare,
  github: IconBrandGithub,
  gitlab: IconBrandGitlab,
  google: IconBrandGoogle,
  instagram: IconBrandInstagram,
  line: IconBrandLine,
  linkedin: IconBrandLinkedin,
  mastodon: IconBrandMastodon,
  medium: IconBrandMedium,
  "microsoft-entra-id": IconBrandWindows,
  nextcloud: IconBrandNextcloud,
  notion: IconBrandNotion,
  patreon: IconBrandPatreon,
  pinterest: IconBrandPinterest,
  reddit: IconBrandReddit,
  slack: IconBrandSlack,
  spotify: IconBrandSpotify,
  strava: IconBrandStrava,
  threads: IconBrandThreads,
  tiktok: IconBrandTiktok,
  twitch: IconBrandTwitch,
  twitter: IconBrandX,
  wechat: IconBrandWechat,
  wordpress: IconBrandWordpress,
  yandex: IconBrandYandex,
  zoom: IconBrandZoom,
}

export const FallbackIcon = IconBrandOauth
